import { Env } from "util/environment-helper";

export const Endpoints = {
  apiRoot: Env.apiRoot || "/api",
};
